import { useNavigate, useParams } from "react-router-dom";
import { useLocales, useUser } from "../../hooks";
import { saveHandler } from "../../handlers";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useGetOneByIdQuery } from "../../features/api/Api";
import { Form, Formik } from "formik";
import { selectCustomerDisabledFields } from "../../features/customer/customerSlice";
import CustomerDateInput from "../applications/common/CustomerDateInput";
import { Grid } from "@mui/material";
import {
  clean,
  customerKindEnum,
  customerKindOptions,
  customerTypeEnum,
  isExists,
  locale,
  onlyNumberKey,
} from "../../utils";

import {
  DateInput,
  FormFooter,
  RadioInput,
  ReferenceDropDown,
  TCInput,
  TextInput,
  VknInput,
} from "../../components";

export default function CustomerGeneral() {
  const { customerId } = useParams();
  const { user } = useUser();

  const disabledFields = useAppSelector(selectCustomerDisabledFields);
  const history = useNavigate();

  const dispatch = useAppDispatch();
  const { data: customer } = useGetOneByIdQuery<any>({
    resource: "fixity/customer/customer",
    id: customerId,
  });
  const update = () => {};
  const { translate } = useLocales();
  const submitHandler = (values: any, { setSubmitting }: any) => {
    saveHandler(clean(values), { setSubmitting }, update);
  };

  const isForeign: boolean = customer?.values?.customerDetail?.isForeign;

  return (
    <div>
      {isExists(customer?.data) ? (
        <Formik
          initialValues={{
            ...customer?.data,
            creatorId: user?.customerId,
            customerDetail: {
              ...customer.data.customerDetail,
              isSupplier: isExists(
                customer.data.customerDetail?.supplierTypeId
              ),
            },
          }}
          onSubmit={submitHandler}
        >
          {(props) => (
            <Form>
              <Grid container spacing={3} justifyContent="center">
                <Grid item md={12}>
                  <RadioInput
                    name="customerKindId"
                    label={translate("resources.customers.customerKind")}
                    disabled={true}
                    radioGroup={locale(
                      customerKindOptions,
                      "resources.customers."
                    )}
                  />
                </Grid>
                {Number(props.values.customerKindId) ===
                customerKindEnum.indivual ? (
                  <>
                    {Number(props.values.customerTypeId) !==
                      customerTypeEnum.lead && (
                      <Grid item md={6}>
                        <TCInput
                          name="citizenOrTaxNumber"
                          label={translate("resources.customers.tckn")}
                          onKeyPressCapture={(event: any) =>
                            onlyNumberKey(event)
                          }
                          disabled={true}
                        />
                      </Grid>
                    )}
                    <Grid item md={6}>
                      {Number(props.values.customerTypeId) ===
                      customerTypeEnum.real ? (
                        <TextInput
                          name="name"
                          label={translate("resources.customers.name")}
                          disabled={true}
                        />
                      ) : null}
                    </Grid>
                    <Grid item md={6}>
                      <TextInput
                        name="surname"
                        label={translate("resources.customers.surname")}
                        disabled={true}
                      />
                    </Grid>
                    {/* <CustomerDateInput /> */}
                    <Grid item md={6} lg={6} xs={12} sm={12}>
                      <DateInput
                        name="dateOfBirth"
                        label={translate("dateOfBirth")}
                        disabled={true}
                      />
                    </Grid>
                  </>
                ) : (
                  <>
                    {Number(props.values.customerKindId) ===
                    customerKindEnum.soleProprietorship ? (
                      <Grid item md={6}>
                        <TCInput
                          name="citizenOrTaxNumber"
                          label={translate("resources.customers.tckn")}
                          onKeyPressCapture={(event: any) =>
                            onlyNumberKey(event)
                          }
                          disabled={true}
                        />
                      </Grid>
                    ) : (
                      <Grid item md={6}>
                        <VknInput
                          name="citizenOrTaxNumber"
                          label={translate("resources.customers.vkn")}
                          onKeyPressCapture={(event: any) =>
                            onlyNumberKey(event)
                          }
                          disabled={true}
                        />
                      </Grid>
                    )}
                    <Grid item md={6}>
                      {Number(props.values.customerTypeId) ===
                      customerTypeEnum.real ? (
                        <TextInput
                          name="commercialTitle"
                          label={translate(
                            "resources.customers.commercialTitle"
                          )}
                          disabled={true}
                        />
                      ) : null}
                    </Grid>
                    <Grid item md={6}>
                      <TextInput
                        name="alias"
                        label={translate("resources.customers.alias")}
                        disabled={true}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <ReferenceDropDown
                        name="customerDetail.taxOfficeId"
                        label={translate("resources.customers.tax_office")}
                        reference="fixity/customer/taxOffice"
                        optionName="name"
                        disabled={true}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
              <FormFooter>
                <Grid container spacing={3} justifyContent="center">
                  <Grid item>{/* <EditButton disabled={true} /> */}</Grid>
                  <Grid item></Grid>
                </Grid>
              </FormFooter>
            </Form>
          )}
        </Formik>
      ) : null}
    </div>
  );
}
